import Layout from '@/components/layout/Layout';

export const Terms = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 max-w-4xl py-12 md:py-16">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-2">
          Termos de Uso
        </h1>
        <p className="text-slate-500 text-sm mb-8">Ultima atualizacao: 01 de fevereiro de 2026</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
          <p>
            Ao acessar e utilizar o site <strong>Carvalho Comercio</strong>, voce concorda com os termos e condicoes descritos abaixo. Caso nao concorde com algum dos termos, solicitamos que nao utilize o site.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">1. Sobre o Site</h2>
          <p>
            O Carvalho Comercio e um site de curadoria de ofertas e promocoes da internet. Nosso objetivo e reunir as melhores oportunidades de compra de diversas lojas parceiras (Amazon, Shopee, Mercado Livre, Temu, Shein, Hotmart, entre outras) em um unico lugar para facilitar a vida do consumidor brasileiro.
          </p>
          <p>
            <strong>Nao somos uma loja virtual.</strong> Nao vendemos produtos diretamente, nao processamos pagamentos e nao gerenciamos estoques. Todas as compras sao realizadas diretamente nos sites das lojas parceiras.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">2. Links de Afiliados</h2>
          <p>
            Este site utiliza links de afiliados. Isso significa que, ao clicar em um link de produto e efetuar uma compra no site da loja parceira, o Carvalho Comercio pode receber uma pequena comissao pela indicacao, sem nenhum custo adicional para voce. Essa comissao e a principal forma de financiamento do site.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">3. Precos e Disponibilidade</h2>
          <p>
            Os precos e disponibilidade dos produtos exibidos neste site sao fornecidos pelas lojas parceiras e podem sofrer alteracoes a qualquer momento sem aviso previo. Recomendamos que voce verifique o preco final diretamente no site da loja antes de concluir sua compra.
          </p>
          <p>
            O Carvalho Comercio nao se responsabiliza por diferencas de preco entre o valor exibido no nosso site e o valor cobrado pela loja parceira no momento da compra.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">4. Responsabilidades</h2>
          <p>O Carvalho Comercio <strong>nao se responsabiliza</strong> por:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>A qualidade, entrega, troca ou devolucao dos produtos adquiridos nas lojas parceiras.</li>
            <li>Eventuais problemas tecnicos nos sites das lojas parceiras.</li>
            <li>Ofertas expiradas ou indisponiveis apos a publicacao.</li>
            <li>Danos diretos ou indiretos resultantes do uso deste site.</li>
          </ul>
          <p>
            Quaisquer reclamacoes referentes a compras devem ser direcionadas diretamente ao Servico de Atendimento ao Cliente (SAC) da respectiva loja onde a compra foi realizada.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">5. Propriedade Intelectual</h2>
          <p>
            Todo o conteudo do site, incluindo textos, imagens, logotipos, layout e codigo-fonte, e de propriedade do Carvalho Comercio ou utilizado com devida autorizacao. E proibida a reproducao, distribuicao ou modificacao sem autorizacao previa e por escrito.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">6. Cadastro no Grupo WhatsApp</h2>
          <p>
            Ao fornecer seu nome e telefone para entrar no nosso grupo de ofertas no WhatsApp, voce consente em receber mensagens com promocoes e ofertas selecionadas. Voce pode sair do grupo a qualquer momento.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">7. Alteracoes nos Termos</h2>
          <p>
            Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. As alteracoes entrarao em vigor imediatamente apos sua publicacao no site.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">8. Contato</h2>
          <p>
            Para duvidas ou sugestoes, entre em contato pelo e-mail: <a href="mailto:carvalhocomercio7@gmail.com" className="text-orange-600 font-medium hover:underline">carvalhocomercio7@gmail.com</a>
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">9. Foro</h2>
          <p>
            Fica eleito o foro da comarca do domicilio do usuario para dirimir eventuais controversias oriundas destes Termos de Uso, em conformidade com a legislacao brasileira vigente.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
